import { renderBook } from "./views/book";
import { renderCreate } from "./views/create";
import { renderEvent, showNotFound } from "./views/event";

const mount = document.getElementById("app");
if (!mount) throw new Error("missing #app");
const app: HTMLElement = mount;

const HEADER_SELECTOR = "header.site";

function measureHeaderHeight(): void {
  const header = document.querySelector(HEADER_SELECTOR);
  if (!(header instanceof HTMLElement)) return;
  document.documentElement.style.setProperty("--header-h", `${Math.ceil(header.getBoundingClientRect().height)}px`);
}

let current: { destroy(): void } | null = null;

function teardown(): void {
  current?.destroy();
  current = null;
}

function mountBook(): { destroy(): void } {
  const box: { current: () => void } = { current: () => {} };
  void renderBook(app).then((handle) => {
    box.current = handle.destroy;
  });
  return { destroy: () => box.current() };
}

function route(): void {
  teardown();
  const path = location.pathname.replace(/\/$/, "") || "/";
  if (path.startsWith("/e/")) {
    const m = path.match(/^\/e\/([A-Za-z0-9_-]{10})$/);
    if (m && m[1]) {
      current = renderEvent(app, m[1]);
    } else {
      showNotFound(app);
    }
    return;
  }
  if (path === "/book") {
    current = mountBook();
    return;
  }
  current = renderCreate(app);
}

window.addEventListener("popstate", route);
window.addEventListener("resize", measureHeaderHeight);
measureHeaderHeight();
route();
